import React from "react";

function QuizView() {
    return <p>Your generated quiz will appear here.</p>;
}

export default QuizView;
